var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "green-building-certificate__table-group",
      class: { isEdit: _vm.isEdit },
    },
    [
      _vm.dataSource.length > 0
        ? _c("table", { staticClass: "green-building-certificate__table" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", { staticClass: "index" }, [
                    _vm._v("\n          #\n        "),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.columns, function (column) {
                    var _obj
                    return _c(
                      "th",
                      {
                        key: column.dataIndex,
                        class:
                          ((_obj = { "required-flag": _vm.isEdit }),
                          (_obj[column.dataIndex] = true),
                          _obj),
                      },
                      [_vm._v(_vm._s(column.title))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.isEdit ? _c("th") : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.dataSource, function (item, index) {
                return _c(
                  "tr",
                  { key: index },
                  [
                    _c("td", { staticClass: "index" }, [
                      _vm._v("\n          " + _vm._s(index + 1) + "\n        "),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.columns, function (column) {
                      return _c(
                        "td",
                        { key: column.dataIndex, class: column.dataIndex },
                        [
                          _vm.isEdit && column.component
                            ? _c(
                                column.component.name,
                                _vm._g(
                                  _vm._b(
                                    {
                                      tag: "component",
                                      model: {
                                        value: item[column.dataIndex],
                                        callback: function ($$v) {
                                          _vm.$set(item, column.dataIndex, $$v)
                                        },
                                        expression: "item[column.dataIndex]",
                                      },
                                    },
                                    "component",
                                    column.component.attrs || {},
                                    false
                                  ),
                                  column.component.listeners || {}
                                )
                              )
                            : [
                                column.render
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            column.render(
                                              item[column.dataIndex],
                                              item,
                                              index
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item[column.dataIndex]) +
                                          "\n            "
                                      ),
                                    ],
                              ],
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _vm.isEdit
                      ? _c(
                          "td",
                          [
                            _c("HKLDeleteIcon", {
                              on: {
                                click: function () {
                                  return _vm.deleteRow(index)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEdit && _vm.docDataSource.length > 0
        ? _c(
            "span",
            {
              staticClass: "underline pointer",
              on: {
                click: function () {
                  return _vm.addRow()
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "tenancy.greenOperation.assessments.greenBuildingCertificate.addGreenBuilding"
                    )
                  ) +
                  " +\n  "
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }